import React, { FunctionComponent as FC } from 'react';
import classnames from 'classnames';
import { TabsProvider, TabsConsumer } from './TabsContext';
import TabItem, { ITab } from './Tab';


const ListTabs: FC<any> = ({ className, children }) => (
  <ul className={`nav nav-tabs nav-tabs-md border-0 ${className}`}>{children}</ul>
);

const TabTitleItem: FC<any> = ({ children, innerRef, ...restProps }: any) => (
  <li
    className="nav-item px-4"
    ref={innerRef}
    style={{
      display: 'inline-block',
      transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    }}
    {...restProps}
  >
    {children}
  </li>
);

const ActiveTabBorder: FC<any> = ({ activeTabElement, children, ...restProps }) => {
  const style = {
    height: 3,
    backgroundColor: '#136bfb',
    position: 'absolute',
    bottom: 0,
    transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    willChange: 'left, width',
    width: 0,
    left: 0,
  };

  if (activeTabElement) {
    style.width = activeTabElement.offsetWidth;
    style.left = activeTabElement.offsetLeft;
  }

  return (
    <div style={style} {...restProps}>
      {children}
    </div>
  );
};

const TabAnchorItem: FC<any> = ({ isActiveTab, children, ...restProps }) => (
  <a
    type="button"
    className={classnames('nav-link border-0 py-2', {
      active: isActiveTab,
      'font-weight-bold': isActiveTab,
    })}
    {...restProps}
  >
    {children}
  </a>
);

const TabsContainer: FC<any> = ({ children, ...restProps }) => (
  <div
    className="d-flex justify-content-between align-items-center"
    style={{
      position: 'relative',
      borderBottom: '1px solid #E3EBF6',
    }}
    {...restProps}
  >
    {children}
  </div>
);

const ReactTabs: FC<any> = ({ children, ...restProps }) => (
  <div
    style={{
      position: 'realative',
    }}
    {...restProps}
  >
    {children}
  </div>
);

class Tabs extends React.Component<any> {
  static Tab = TabItem;

  state = {
    tabsElements: [],
  };

  render() {
    return (
      <TabsProvider
        activeTab={{
          id: this.props.activeTabId,
        }}
      >
        <TabsConsumer>
          {(value: any) => (
            <ReactTabs>
              <TabsContainer>
                <ListTabs className={this.props.listClassName}>
                  {value.context.tabs.map((tab: ITab, index: number) => (
                    <TabTitleItem
                      key={index}
                      id={tab.id}
                      innerRef={(tabElement: any) => {
                        if (!this.state.tabsElements[tab.id]) {
                          this.setState((prevState: any) => {
                            const { tabsElements } = prevState;
                            tabsElements[tab.id] = tabElement;
                            return {
                              tabsElements,
                            };
                          });
                        }
                      }}
                    >
                      <TabAnchorItem
                        isActiveTab={value.context.activeTab.id === tab.id}
                        href="#"
                        onClick={(event: any) => {
                          event.preventDefault();
                          this.props.onTabChange(tab.id);
                          value.context.onClick(tab)(event);
                        }}
                        onKeyPress={(event: any) => {
                          const code = event.keyCode || event.which;

                          if (code === 13) { // Enter
                            // @ts-ignore
                            this.onClick(tab)(event);
                          }
                        }}
                      >
                        {tab.title}
                      </TabAnchorItem>
                    </TabTitleItem>
                  ))}
                </ListTabs>
                {this.props.tabsHeaderChildren}

                <ActiveTabBorder
                  activeTabElement={
                    this.state.tabsElements[value.context.activeTab.id]
                  }
                />
              </TabsContainer>

              {this.props.children}
            </ReactTabs>
          )}
        </TabsConsumer>
      </TabsProvider>
    );
  }
}

export { Tabs, TabItem as Tab };
